module.exports = __webpack_public_path__ + "static/media/money-packs-icon.e4cf2d43.svg";